import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=28ac705e&scoped=true&"
import script from "./ProductAdd.vue?vue&type=script&lang=ts&"
export * from "./ProductAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&id=28ac705e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac705e",
  null
  
)

export default component.exports